import PageBanner from "@/components/feature/PageBanner";
import ScheduleSection from "@/components/feature/schedule/ScheduleSection";

// /calendar 페이지 — 메인 홈의 달력 섹션과 «같은 컴포넌트» 를 사용한다.
export default function CalendarPage() {
  return (
    <>
      <PageBanner
        title="일정"
        description="정기모임 · 봉사일정 · 회원 생일과 출근도장을 한 달력에서 확인하세요."
        breadcrumb={[{ label: "일정" }]}
      />

      <section className="w-full px-4 py-10 md:px-6 md:py-12">
        <div className="mx-auto max-w-6xl">
          <ScheduleSection />
        </div>
      </section>
    </>
  );
}